import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import HeroSection from './components/HeroSection';
import CompanyHistory from './components/CompanyHistory';
import TeamExpertise from './components/TeamExpertise';
import MissionValues from './components/MissionValues';
import Achievements from './components/Achievements';
import Facilities from './components/Facilities';

const AboutUs = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background overflow-x-hidden about-us-page">
      {/* Header */}
      <Header />
      {/* Main Content */}
      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-muted/30 py-4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Breadcrumb />
          </div>
        </div>

        {/* Page Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          {/* Hero Section */}
          <HeroSection />

          {/* Company History */}
          <CompanyHistory />

          {/* Mission & Values */}
          <MissionValues />

          {/* Team Expertise */}
          {/* <TeamExpertise /> */}

          {/* Achievements */}
          <Achievements />

          {/* Facilities */}
          {/* <Facilities /> */}  
        </motion.div>
      </main>
      {/* Footer */}
      <footer className="bg-secondary text-secondary-foreground py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
                  </svg>
                </div>
                <div>
                  <div className="text-lg font-semibold">Endosurgery</div>
                  <div className="text-sm text-secondary-foreground/70">Malaysia</div>
                </div>
              </div>
              <p className="text-sm text-secondary-foreground/70 leading-relaxed">
                Leading Malaysia's medical innovation with cutting-edge endoscopic and surgical solutions since 2012.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="/homepage" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">Home</a></li>
                <li><a href="/about-us" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">About Us</a></li>
                <li><a href="/product-portfolio" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">Products</a></li>
                <li><a href="/contact" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">Contact</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2">
                <li className="text-sm text-secondary-foreground/70">
                  Level 12, Menara Axiata<br />
                  Kuala Lumpur Sentral
                </li>
                <li className="text-sm text-secondary-foreground/70">+60 3-2274 8888</li>
                <li className="text-sm text-secondary-foreground/70">info@endosurgery.com.my</li>
              </ul>
            </div>

            {/* Certifications */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Certifications</h4>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-success rounded-full"></div>
                  <span className="text-sm text-secondary-foreground/70">GDPMD Certified</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary rounded-full"></div>
                  <span className="text-sm text-secondary-foreground/70">ISO 13485</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-accent rounded-full"></div>
                  <span className="text-sm text-secondary-foreground/70">CE Marking</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-secondary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-secondary-foreground/70">
              © {new Date()?.getFullYear()} Endosurgery Sdn Bhd. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="/privacy-policy" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">Privacy Policy</a>
              <a href="/terms-of-service" className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;